import { Typography, styled } from "@mui/material";
import { NavLink } from "react-router-dom-v5-compat";
/**
 * The TypographyNavLink component is a styled component that extends the MUI Typography component.
 * It is used to create a Typography component that is also a React-Router NavLink.
 * @default typography-variant: "h4"
 */
export const TypographyNavLink = styled(Typography)(({ theme }) => ({
    textDecoration: "none",
    color: theme.palette.grey[`A700`],
    "&.active": {
        textDecoration: "underline",
        textDecorationThickness: "2px",
        textUnderlinePosition: "under",
        textUnderlineOffset: "2px",
        textDecorationColor: theme.palette.primary.main,
        color: theme.palette.common.black,
    },
    "&.is-logged-out-nav": {
        color: theme.palette.common.black,
    },
}));
/**
 * Sets the default props. DO NOT CHANGE.
 * If additional customizations are required, creating a new styled component is likely the better approach.
 */
TypographyNavLink.defaultProps = {
    component: NavLink,
    variant: "h4", // The default variant for the typography nav link component.
};
